import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    cellButton: {
      textTransform: 'inherit',
      justifyContent: 'inherit',
      height: '100%',
      margin: theme.spacing(0, -1.25),
      width: `calc(100% + ${theme.spacing(2.5)})`,
      padding: theme.spacing(0, 1.25),
      borderRadius: 0,
    },
  };
};
